import React from 'react';
import PropTypes from 'prop-types';
import withContext from 'app/withContext';
import { Redirect } from 'react-router';
import { buildPath } from 'services/routing';

export function ProfileRedirect(props) {
  // eslint-disable-next-line react/prop-types, no-unused-vars
  const { profileId, params, history, location, match, staticContext, dispatch, to, ...rest } = props;

  return <Redirect to={buildPath(to, { profileId, ...params })} {...rest} />;
}

ProfileRedirect.propTypes = {
  to: PropTypes.string.isRequired,
  params: PropTypes.shape(),
  // context
  profileId: PropTypes.string.isRequired
};

export default withContext(ProfileRedirect);
